// extracted by mini-css-extract-plugin
export default {"loadingSec":"SomthingWrong_loadingSec__IcdC+"};